import React from 'react';
import { EmployeeCard } from './EmployeeCard';


/**
 * EmployeeGrid Component - Renders the employee list as a grid of tiles.
 */
export function EmployeeGrid({ 
    employees, 
    absences, 
    onStartEdit,
    onDelete,
    onManageAbsence
}) {
    return (
        <div className="employee-card-grid">
            {employees.map(emp => (
                <EmployeeCard
                    key={emp.id}
                    emp={emp}
                    absences={absences}
                    employees={employees}
                    onManageAbsence={() => onManageAbsence(emp.id)}
                    onEdit={() => onStartEdit(emp)}
                    onDelete={() => onDelete(emp.id)}
                />
            ))}
        </div>
    );
}
